import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
// import LinkIcon from "@mui/icons-material/Link";

function Page() {
  const [sidenavdesign, setSidenavdesign] = useState(false);
  const [userprofile, setUserprofile] = useState(false);
  const [show, setShow] = useState(false);
  const location = useLocation();
  const navigator = useNavigate();
  // console.log("location----->", location.pathname);

  const Auth = localStorage.getItem("Quizetoken");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const modelDisplay = () => {
    handleShow();
  };

  const logoutFun = () => {
    // localStorage.removeItem("Quizetoken")
    // localStorage.removeItem("UserIdclient")
    // localStorage.removeItem("UserIdMongo")
    localStorage.clear();
    window.location.reload();

    // navigator("/");
    handleClose();
  };

  useEffect(() => {
    if (Auth) {
      setUserprofile(true);
    } else {
      setUserprofile(false);
      navigator("/");
    }
  }, [Auth]);

  return (
    <>
      <aside
        // id="sidebar"
        onClick={(event) => {
          event.stopPropagation();
          setSidenavdesign(!sidenavdesign);
        }}
        // className={`sidebar break-point-sm has-bg-image ${
        //   sidenavdesign ? "collapsed" : ""
        // }`}
        className="sidebar break-point-sm has-bg-image"
      >
        {/* <aside id="sidebar" className="sidebar break-point-sm has-bg-image"> */}

        <a className="sidebar-collapser">
          <i className="fa-solid fa-bars"></i>
        </a>

        <div className="sidebar-layout">
          <div className="sidebar-header"></div>
          <div className="sidebar-content">
            <nav className="menu open-current-submenu">
              <ul>
                <li
                  className={`menu-item sub-menu ${
                    location.pathname === "/instruction"
                      ? "navstylecoloractive"
                      : ""
                  }`}
                >
                  <Link to="/instruction">
                    <span className="menu-icon">
                      <span className="material-symbols-outlined">info</span>
                    </span>
                    <span className="menu-title">Instructions</span>
                  </Link>
                  <div className="sub-menu-list"></div>
                </li>

                {userprofile ? (
                  <>
                    <li
                      className={`menu-item sub-menu ${
                        location.pathname === "/leaderboard"
                          ? "navstylecoloractive"
                          : ""
                      }`}
                    >
                      <Link to="/leaderboard">
                        {/* <span className="menu-icon"> */}
                        <span
                          className={`menu-icon ${
                            location.pathname === "/leaderboard"
                              ? "navstylecoloractive"
                              : ""
                          }`}
                        >
                          <span className="material-symbols-outlined">
                            {/* <span className={`material-symbols-outlined ${location.pathname === '/leaderboard' ? 'navstylecoloractive' : ''}`}> */}
                            leaderboard
                          </span>
                        </span>
                        <span
                          className={`menu-title ${
                            location.pathname === "/leaderboard"
                              ? "navstylecoloractive"
                              : ""
                          }`}
                        >
                          Leaderboard
                        </span>
                      </Link>
                      <div className="sub-menu-list"></div>
                    </li>
                    <li
                      className={`menu-item sub-menu ${
                        location.pathname === "/free-game-leaderboard"
                          ? "navstylecoloractive"
                          : ""
                      }`}
                    >
                      <Link to="/free-game-leaderboard">
                        {/* <span className="menu-icon"> */}
                        <span
                          className={`menu-icon ${
                            location.pathname === "/free-game-leaderboard"
                              ? "navstylecoloractive"
                              : ""
                          }`}
                        >
                          <span className="material-symbols-outlined">
                            {/* <span className={`material-symbols-outlined ${location.pathname === '/leaderboard' ? 'navstylecoloractive' : ''}`}> */}
                            leaderboard
                          </span>
                        </span>
                        <span
                          className={`menu-title ${
                            location.pathname === "/free-game-leaderboard"
                              ? "navstylecoloractive"
                              : ""
                          }`}
                        >
                          Free Game Leaderboard
                        </span>
                      </Link>
                      <div className="sub-menu-list"></div>
                    </li>
                    <li
                      className={`menu-item sub-menu ${
                        location.pathname === "/" ? "navstylecoloractive" : ""
                      }`}
                    >
                      <Link to="/">
                        <span className="menu-icon">
                          {/* <span className="material-symbols-outlined">
                            receipt_long
                          </span> */}
                          <span className="material-symbols-outlined">
                            sports_esports
                          </span>
                        </span>
                        <span className="menu-title">Play Now</span>
                      </Link>
                      <div className="sub-menu-list"></div>
                    </li>

                    <li
                      className={`menu-item sub-menu ${
                        location.pathname === "/transaction-history"
                          ? "navstylecoloractive"
                          : ""
                      }`}
                    >
                      <Link to="/transaction-history">
                        <span className="menu-icon">
                          <span className="material-symbols-outlined">
                            receipt_long
                          </span>
                        </span>
                        <span className="menu-title">Transaction History</span>
                      </Link>
                      <div className="sub-menu-list"></div>
                    </li>

                    <li
                      className={`menu-item sub-menu ${
                        location.pathname === "/rewards"
                          ? "navstylecoloractive"
                          : ""
                      }`}
                    >
                      <Link to="/rewards">
                        <span className="menu-icon">
                          <span className="material-symbols-outlined">
                            receipt_long
                          </span>
                        </span>
                        <span className="menu-title">Rewards</span>
                      </Link>
                      <div className="sub-menu-list"></div>
                    </li>

                    <li
                      className={`menu-item sub-menu ${
                        location.pathname === "/wallet"
                          ? "navstylecoloractive"
                          : ""
                      }`}
                    >
                      <Link to="/wallet">
                        <span className="menu-icon">
                          <span className="material-symbols-outlined">
                            wallet
                          </span>
                        </span>

                        <span className="menu-title">Connect Wallet</span>
                      </Link>
                      <div className="sub-menu-list"></div>
                    </li>

                    <li
                      className={`menu-item sub-menu ${
                        location.pathname === "/profile"
                          ? "navstylecoloractive"
                          : ""
                      }`}
                    >
                      <Link to="/profile">
                        <span className="menu-icon">
                          <span className="material-symbols-outlined">
                            account_circle
                          </span>
                        </span>
                        <span className="menu-title">Profile</span>
                      </Link>
                      <div className="sub-menu-list"></div>
                    </li>

                    <li
                      className={`menu-item sub-menu ${
                        location.pathname === "/referral-link"
                          ? "navstylecoloractive"
                          : ""
                      }`}
                    >
                      <Link to="/referral-link">
                        <span className="menu-icon">
                          <span className="material-symbols-outlined">
                            {/* <LinkIcon /> */}
                            insert_link
                          </span>
                        </span>
                        <span className="menu-title">Referral Link</span>
                      </Link>
                      <div className="sub-menu-list"></div>
                    </li>

                    <li className="menu-item sub-menu">
                      <a onClick={() => modelDisplay()}>
                        <span className="menu-icon">
                          <span className="material-symbols-outlined">
                            logout
                          </span>
                        </span>
                        <span className="menu-title">Log Out</span>
                      </a>
                      <div className="sub-menu-list"></div>
                    </li>
                  </>
                ) : (
                  <li className="menu-item sub-menu">
                    <Link to="/login">
                      <span className="menu-icon">
                        <span className="material-symbols-outlined">login</span>
                      </span>
                      <span
                        className={`menu-title ${
                          location.pathname === "/login"
                            ? "navstylecoloractive"
                            : ""
                        }`}
                      >
                        Log In
                      </span>
                    </Link>
                    <div className="sub-menu-list"></div>
                  </li>
                )}
              </ul>
            </nav>
          </div>
          {/* <div className="sidebar-footer">

                </div> */}

          <Modal
            show={show}
            onHide={handleClose}
            centered
            size="lg"
            aria-labelledby="example-modal-sizes-title-lg"
          >
            {/* <Modal.Body></Modal.Body> */}
            <div className="Coupon-details pd-0">
              <div className="about-logout profile-logout">
                <img src="/assets/images/logout.png" className="log-out" />
                <h4>
                  Are you sure, <span>you want to logout?</span>
                </h4>
                <div className="logout-btn">
                  <a onClick={() => setShow(false)}>Cancel</a>
                  <a onClick={() => logoutFun()} className="logout">
                    Logout
                  </a>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </aside>
    </>
  );
}

export default Page;
